// extracted by mini-css-extract-plugin
module.exports = {"custom__checkbox__block":"customCheckbox_custom__checkbox__block__IBzUZ","custom__checkbox__input":"customCheckbox_custom__checkbox__input__h2pjO"};